import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectPRLoader } from 'src/store/selectors/PropertyLoader';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import ModernizedNotes from 'src/components/Notes/ModernizedNotes';
import { useNotesAPI } from 'src/SharedCustomHooks/UseNotesAPI/useNotesAPI';

interface ContactNotesProps {
  contact: { id: string };
  reFetchContactCountsFromAPI?: () => void;
}

const HIDDEN_ADD_ROLES: string[] = [
  'Strata Manager',
  'Vendor',
  'Home Owner',
  'Realtor',
  'Occupant',
];

const ContactNotes = ({
  contact,
  reFetchContactCountsFromAPI,
}: ContactNotesProps) => {
  const user: any = useSelector(selectAuthenticatedUser);
  const prLoader: any = useSelector(selectPRLoader);

  const notesAPI = useNotesAPI(user);

  useEffect(() => {
    if (contact?.id) {
      void notesAPI.fetchNotes(contact.id);
    }
  }, [contact?.id]);

  const userRole: string = user?.roles?.[0]?.role?.name || '';
  const canAddNotes: boolean = !HIDDEN_ADD_ROLES.includes(userRole);

  const isLoading: boolean =
    prLoader || (notesAPI.loadingNotes && notesAPI.notes.length === 0);

  return (
    <ModernizedNotes
      notesAPI={notesAPI}
      entityId={contact.id}
      itemType="Contact"
      userId={user.id}
      canAddNote={canAddNotes}
      canDelete={true}
      loading={isLoading}
      afterMutate={reFetchContactCountsFromAPI}
      addDialogTitle="Add Contact Note"
      editDialogTitle="Edit Contact Note"
      addDialogDescription="Add a private note for this contact."
    />
  );
};

export default ContactNotes;
